import React, { useState, useEffect, cloneElement } from "react";
import { useMap } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";

//scss
import "./LayerControl.scoped.scss";

const LayerControl = ({ children, refs }) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const [mapType, setMapType] = useState(null);
	const dispatch = useDispatch();
	const mapInfo = useSelector(state => state.map);
	const map = useMap();

	const controlProps = {};
	const openMenu = () => setMenuOpen(true);
	const closeMenu = () => setMenuOpen(false);

	const init = () => {
		setMapType(+mapInfo.type);
		refs.current.forEach(({ current: layer }) => {
			if (layer == null) return true;

			if (+layer.options.id === +mapType) {
				map.addLayer(layer);
				return;
			}

			map.removeLayer(layer);
		});
	};

	const changeMap = id => {
		if (+mapType === +id) return;
		setMapType(+id);
		dispatch({ type: "MAP_TYPE_SET", state: id });
		document.dispatchEvent(new CustomEvent("map_change"));
	};

	useEffect(init, [map, mapInfo.type, mapType, refs]);

	return (
		<div onMouseEnter={openMenu} onMouseLeave={closeMenu} className="layer_control">
			<div className={menuOpen ? "icon icon--hidden" : "icon"}>
				<i className="fas fa-layer-group" />
			</div>

			<div className={menuOpen ? "content" : "content content--hidden"}>
				{children.map(child => cloneElement(child, { ...controlProps, key: child.props.id }))}

				{children.map(({ props: { id, name, img, filter = false } }) => (
					<div
						className={`map_preview ${+mapType === +id && "selected"} ${filter && "filter"}`}
						onClick={() => changeMap(id)}
						key={id}
					>
						<img src={img} alt={name} />
						<p>{name}</p>
					</div>
				))}
			</div>
		</div>
	);
};

const LayerControlItem = ({ id, children }) => cloneElement(children, { key: id, id });

export { LayerControlItem };
export default LayerControl;
